const initialState = { access_token: {}, profile: {} };

const user = (state = Object.assign({}, initialState), action) => {
  switch (action.type) {
    case "SET_ACCESS_TOKEN":
      state.access_token = action.data;
      return Object.assign({}, state);
    case "SET_IMPERSONATE_PROFILE":
      state.profile = Object.assign({}, action.data);
      return Object.assign({}, state);
    case "SET_PROFILE":
      state.profile = Object.assign(state.profile, action.data);
      return Object.assign({}, state);
    case "UPDATE_PROFILE":
      state.profile = Object.assign({}, action.data);
      return Object.assign({}, state);
    case "REFRESH_ACCESS_TOKEN":
      state.access_token = Object.assign(state.data.access_token, action.data);
      return Object.assign({}, state);
    case "LOGOUT":
      return Object.assign({}, initialState);
    // SAM-088: fired when another tab writes a new `user` slice to localStorage
    // (login/logout/token refresh there) so this tab's redux state catches up
    // without needing a hard refresh.
    case "HYDRATE_USER":
      return Object.assign({}, initialState, action.data);
    default:
      return state;
  }
};

export default user;
